import React from 'react';
import logo from '../../assets/logo_name_white.png';
import useAuth from 'hooks/useAuth';
import styles from '../Login/login.module.scss';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';

const LoginCode = () => {
  const { errorData } = useSelector((state) => state.auth);

  const {
    loginCodeData,
    loginCodeStep,
    loginCodeError,
    handleLoginCodePhoneChange,
    handleLoginCodeChange,
    requestLoginCodeUser,
    loginUserWithCode,
    goBackLoginCode,
    toLogin,
  } = useAuth();

  const isCodeStep = loginCodeStep === 2;

  return (
    <div className={styles.imageContainer}>
      <div className={styles.container}>
        <img src={logo} className={styles.logo} alt="cado logo" />
        <form
          className={styles.infoContainer}
          onSubmit={(e) =>
            isCodeStep
              ? loginUserWithCode(e, loginCodeData)
              : requestLoginCodeUser(e, loginCodeData)
          }
        >
          <div className={styles.styleInfoContainer}>
            <div className={styles.headerContainer}>
              <p className={styles.authHeader}>Iniciar Sesión</p>
              <p className={styles.authText}>
                {isCodeStep
                  ? 'Ingresa el código que enviamos a tu teléfono.'
                  : 'Ingresa tu teléfono y te enviaremos un código para acceder a Cado.'}
              </p>
            </div>
            <div className={styles.inputContainer}>
              {!isCodeStep ? (
                <div
                  className={styles.individualInputContainer}
                  data-error={loginCodeError ? loginCodeError.phone : null}
                >
                  <PhoneInput
                    type="text"
                    value={loginCodeData.phone}
                    defaultCountry="EC"
                    name="phone"
                    placeholder="Teléfono"
                    onChange={(e) => handleLoginCodePhoneChange(e)}
                    className={styles.input}
                    required
                    style={{ padding: '16px 16px', height: '54px' }}
                  />
                </div>
              ) : (
                <div
                  className={styles.individualInputContainer}
                  data-error={loginCodeError ? loginCodeError.code : null}
                >
                  <input
                    type="text"
                    value={loginCodeData.code}
                    name="code"
                    placeholder="Código"
                    onChange={(e) => handleLoginCodeChange(e)}
                    className={styles.input}
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    maxLength={6}
                    required
                    autoFocus
                  />
                </div>
              )}
              {typeof loginCodeError === 'string' ? (
                <span className={styles.errorSpan}>{loginCodeError}</span>
              ) : (
                ''
              )}
              {typeof errorData === 'string' ? (
                <span className={styles.errorSpan}>{errorData}</span>
              ) : errorData?.message ? (
                <span className={styles.errorSpan}>
                  {errorData.message}.{' '}
                  <a href={errorData.link} className={styles.toRecover}>
                    {errorData.linkLabel}
                  </a>
                </span>
              ) : (
                ''
              )}
              <Toaster position="top-center" />
              <div className={styles.navigateContainer}>
                <a className={styles.toRecover} onClick={(e) => toLogin(e)}>
                  Ingresar con contraseña
                </a>
                {isCodeStep ? (
                  <a className={styles.register} onClick={(e) => goBackLoginCode(e)}>
                    Cambiar teléfono
                  </a>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <input
              type="submit"
              value={isCodeStep ? 'Iniciar Sesión' : 'Enviar Código'}
              disabled={isCodeStep ? !loginCodeData.code : !loginCodeData.phone}
              className={styles.submitAuth}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginCode;
